import { TFunction } from "i18next";

export interface ExportConfig {
  todayStr: string;
  fileSafeTitle: string;
  exportFileName: string;
  customLines: string[];
  printHeader: string;
}

/**
 * Generates standardized export configuration for CSV and Print exports
 * @param pageTitle - The translated page title to use in the export
 * @param t - The translation function
 * @returns Export configuration object with file name, CSV lines, and print header
 */
export function generateExportConfig(
  pageTitle: string,
  t: TFunction<"translation", undefined>,
): ExportConfig {
  const todayStr = new Date().toISOString().slice(0, 10);
  const fileSafeTitle = pageTitle
    .replace(/[\\/:*?"<>|]/g, "")
    .trim()
    .slice(0, 80);
  const exportFileName = `Pinnacle ${fileSafeTitle} ${todayStr}`;
  
  const customLines = [
    `"Pinnacle";"${t("toolbar.export.exportDate")}: ${todayStr}"`,
    `"${fileSafeTitle}"`,
    `""`,
  ];
  
  const printHeader = `
    <div style="margin-bottom:6mm;">
      <div style="display:flex; align-items:center; margin-bottom:4mm;">
        <img src="${window.location.origin}/icon.svg" style="height:8mm; margin-right:4px;">
        <img src="${window.location.origin}/logo.svg" style="height:8mm; margin-right:8px;">
      </div>
      <br>
      <div style="display:flex; align-items:center;">
        <div style="font-weight:600; font-size:12pt;">${fileSafeTitle}</div>
        <div style="margin-left:auto; font-weight:600; font-size:12pt;">${t("toolbar.export.exportDate")}: ${todayStr}</div>
      </div>
    </div>
  `;
  
  return {
    todayStr,
    fileSafeTitle,
    exportFileName,
    customLines,
    printHeader,
  };
}
